<template>
  <div class="card">
    <div  :class="{'card--transparent': state}">
    <div class="card" :style="{'background-color': habit.color}">
      <div class="row space-between flex-start">
        <h2 class="short-description flex-1">{{habit.name}}</h2>
      </div>
      <div class="row space-between small-top">
        <actions text="Details" icon="info" @click="setState('details')" :active="state === 'details'"/>
        <actions text="Edit" icon="edit" @click="display=true && setState('edit')"/>
        <actions text="Journal" icon="note_add" @click="setState('takeANote')" :active="state === 'takeANote'" />
        <actions text="Delete" icon="delete" @click="remove" />
      </div>
    </div>
    <div class="card information" v-if="state === 'details'">
      <week-btns :week="habit.days_of_week" :color="habit.color" :allowEdit="false" />
      <div class="small-top">{{habit.description}}</div>

      <h2 :style='{"color": habit.color}' class="small-top">How</h2>
      <div>{{habit.visualization}} </div>

      <h2 :style='{"color": habit.color}'>
        Why this
      </h2>
      <div>
        {{habit.why}}
      </div>
    </div>
    <div class="card" v-if="state === 'takeANote'">
      <input style="border-style: none" placeholder="Title" v-model="note.title" class="full-width" />
      <div class="divider" />
      <textarea v-model="note.text" class="full-width task-note" style="min-height: 6em" placeholder="Write something..."/>
      <div class="row align-center">
        <input v-model="note.private" type="checkbox" name="private" style="margin-right: 5px" />
        <label>Private (your coach will not be able to review this)</label>
      </div>
      <button class="btn" :style="{'background-color': habit.color}" @click="createNote" :disabled="loading">Save</button>
    </div>
    </div>
    <habit-modal :habit="habit" @save="saveHabit" v-if="display" @close="display=false" title="Edit" />
    <modal v-if="deleting">
      <div class="card card--default">
        <h-icon class="cancel clickable top-right" @click="deleting=false">cancel</h-icon>
        <h2>Are you sure you want to delete this habit?</h2>
        <button class="btn btn--outline small-top" @click="deleting=false">No</button>
        <button class="btn btn--outline" @click="removeHabit">Yes</button>
      </div>
    </modal>
  </div>
</template>

<script>
import actions from "@/components/h-actions";
import weekBtns from "@/components/weekBtns";
import habitModal from "./habitModal";
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import store from "@/services/api/store";
import modal from "@/components/modal";
const CLIENT_STORE = "ClientHabits";

export default {
  props: ["habit"],
  components: { actions, weekBtns, habitModal, modal },
  data() {
    return {
      state: "",
      note: {},
      loading: false,
      display: false,
      deleting: false,
    };
  },
  methods: {
    remove() {
      this.deleting = true;
      this.setState("deleting");
    },
    removeExercise() {
      this.deleting = false;
      this.$emit("delete");
      this.setState("");
    },
    removeHabit() {
      this.deleting = false;
      this.habit.active = false;
      this.$emit("deleted");
      store.update(CLIENT_STORE, this.habit.id, this.habit)
        .then(() => {
          snackbar.update("Deleted");
        });
    },
    setState(state) {
      if (this.state === state) {
        this.state = "";
      } else {
        this.state = state;
      }
      return true;
    },
    createNote() {
      let promise; 
      if (this.note.id) {
        promise = this.note.save();
      } else {
        promise = dataStore.create("ClientNotes", {
          text: this.note.text,
          title: this.note.title,
          // task: this.exercise.id,
          private: this.note.private
        })
      }

      promise
        .then(note => {
          snackbar.update("Saved");
          this.note = note;
          this.setState(this.state); // toggle
        })
        .finally(() => (this.loading = false));
    },
    saveHabit() {
      this.display = false;
      store.update(CLIENT_STORE, this.habit.id, this.habit)
        .then(() => {
          snackbar.update("Saved");
        });
    }
  },
  computed: {
    displayTransparent() {
      return this.displayDetails || this.takeNote;
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/screenSizes";
.daily-template {
  width: 48%;

  .short-description {
    font-size: 18px;
  }

  textarea {
    background-color: transparent !important;
    color: white !important;
  }

  @media (max-width: @xs) {
    width: 100%;
  }
  @media (max-width: @md) {
    width: 48%;
  }
  .complete {
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 18px;
    }
  }

  .cancel {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
